
import CarrersBanner from "../components/Careers/CarrersBanner";
import CareerForms from "../components/Careers/CareerForms";

const CareersPage = () => {
  return (
    <>
      <CarrersBanner />
      <CareerForms />
    </>
  );
};

export default CareersPage;

